export { ApolloCache } from "./core/cache.js";
export { Cache } from "./core/types/Cache.js";
export { MissingFieldError } from "./core/types/common.js";
export { isReference, makeReference, } from "../utilities/index.js";
export { InMemoryCache, } from "./inmemory/inMemoryCache.js";
export { makeVar, cacheSlot, } from "./inmemory/reactiveVars.js";
export { defaultDataIdFromObject, } from "./inmemory/policies.js";
export * from "./inmemory/types.js";
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@apollo/client/cache/index.js
// module id = ./node_modules/@apollo/client/cache/index.js
// module chunks = 53 54